import { ActionIcon, Group, Paper, TextInput, Button, Box } from "@mantine/core";
import React from "react";
import { X } from "tabler-icons-react";

function AlphabetForm({ form, correction_dp, index }) {
  const choices = form.values.epreuves[index]?.choices || [];

  const handleLetterClick = (letter) => {
    const currentChoices = form.values.epreuves[index]?.choices || [];
    if (!currentChoices.includes(letter)) {
      form.setFieldValue(`epreuves.${index}.choices`, [...currentChoices, letter]);
    }
  };

  const handleRemoveChoice = (letter) => {
    const currentChoices = form.values.epreuves[index]?.choices || [];
    form.setFieldValue(
      `epreuves.${index}.choices`,
      currentChoices.filter((l) => l !== letter)
    );
  };

  return (
    <Paper mb={20} p={10} shadow="xs">
      <Group noWrap position="apart">
        <TextInput
          style={{ flex: 1 }}
          {...form.getInputProps(`epreuves.${index}.titre`)}
          placeholder="Mettre le titre de l'epreuve"
        // mb={10}
        />
        <ActionIcon
          color="red"
          onClick={() => {
            console.log("lalal", index);
            form.removeListItem(`epreuves`, index);
          }}
        >
          <X size="1rem" />
        </ActionIcon>
      </Group>
      <Group mt={10}>
        {correction_dp?.split("-").filter((lettre) => !choices.includes(lettre)).map((lettre, idx) => (
          <Button
            key={idx}
            variant="outline"
            size="xs"
            style={{ width: '40px', padding: 0 }}
            onClick={() => handleLetterClick(lettre)}
          >
            {lettre}
          </Button>
        ))}
      </Group>
      {choices.length > 0 && (
        <Group spacing={5} mt={10}>
          {choices.map((lettre, idx) => (
            <Box key={idx} style={{ display: 'flex', alignItems: 'center' }}>
              <Paper withBorder py={5} px={10} style={{ marginRight: 4 }}>
                {lettre}
              </Paper>
              <ActionIcon color="red" size="xs" onClick={() => handleRemoveChoice(lettre)}>
                <X size="1rem" />
              </ActionIcon>
            </Box>
          ))}
        </Group>
      )}
    </Paper>
  );
}

export default AlphabetForm;
